import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import Card from 'components/Card';
import Button from 'components/Button';
import FileIcon from 'svg/icon-file.svg';
import DownloadIcon from 'svg/icon-download.svg';

function MyCvItem({ cv, extraClasses }) {
  const { t } = useTranslation();

  if (!cv.uploadedFile?.filePath)
    return (
      <Card extraClasses={`c-card--white-background ${extraClasses}`}>
        <div className="o-layout o-layout--gutter-tiny">
          <div className="o-layout__cell o-layout__cell--fit">
            <FileIcon />
          </div>
          <div className="o-layout__cell o-layout__cell--fill">
            {t('cvs.noDownloadableCv')}
          </div>
        </div>
      </Card>
    );

  return (
    <Card extraClasses={`c-card--white-background ${extraClasses}`}>
      <div className="o-layout o-layout--gap-small o-layout--align-middle o-layout--justify-space-between">
        <div className="o-layout__cell o-layout__cell--fit">
          <div className="c-card__cv-title">
            <FileIcon />
            <span>{cv.uploadedFile.filePath}</span>
          </div>
        </div>
        <div className="o-layout__cell o-layout__cell--fit">
          <Button
            Tag="a"
            href={cv.uploadedFile.contentUrl}
            label={t('downloadCv')}
            Icon={DownloadIcon}
            extraClasses="c-button--small c-button--icon-small"
          />
        </div>
      </div>
    </Card>
  );
}

MyCvItem.propTypes = {
  cv: PropTypes.object,
  extraClasses: PropTypes.string,
};

export default MyCvItem;
